var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-size-100 mobile-layout"},[_c('h4',{staticClass:"title text-center"},[_vm._v(_vm._s(_vm.address))]),_c('div',{staticClass:"map",attrs:{"id":"map"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }